export default [{
    path: '/dashboard',
    name: 'dashboard',
    redirect: '/dashboard/my-orders',
    component: () => import('../views/dashboard/Index.vue'),
    meta: {
    },
    children: [
    {
        path: 'my-orders',
        name: 'my-orders',
        component: () => import('../views/dashboard/Orders/Orders.vue'),
        meta: {
            title: 'Studies Weekly Store - My Orders',
        }
    },
    {
        path: 'rewards',
        name: 'rewards',
        component: () => import('../views/dashboard/Rewards.vue'),
        meta: {
            title: "Studies Weekly Store - Rewards",
            auth: {
                roles: ['admin', 'teacher'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'affiliate',
        name: 'affiliate',
        component: () => import('../views/dashboard/Affiliate.vue'),
        meta: {
            title: "Studies Weekly Store - My Affiliate Page",
            auth: {
                roles: ['admin', 'teacher'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'affiliate-posts',
        name: 'affiliate-posts',
        component: () => import('../views/dashboard/AffiliatePosts.vue'),
        props: true,
        meta: {
            title: 'Affiliate Posts - Studies Weekly Store - Products',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'update-tos',
        name: 'update-tos',
        component: () => import('../views/dashboard/Tos.vue'),
        props: true,
        meta: {
            title: 'Update TOS - Studies Weekly Store',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'products',
        name: 'products',
        component: () => import('../views/dashboard/Products.vue'),
        meta: {
            title: 'Studies Weekly Store - Products',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'pages',
        component: () => import('@/views/dashboard/Pages/PageIndex.vue'),
        meta: {
            title: "Studies Weekly Store - Pages Admin",
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        },
        children: [
            {
                path: '',
                name: 'page-list',
                component: () => import('@/views/dashboard/Pages/PageAdmin.vue'),
                meta: { title: 'Studies Weekly Store - Page List'}
            },
            {
                path: 'page-editor/:id',
                name: 'page-editor',
                props: true,
                component: () => import('@/views/dashboard/Pages/PageEditor.vue'),
                meta: { title: 'Studies Weekly Store - Page Editor'}
            },
            {
                path: 'block-editor/:id',
                name: 'block-editor',
                props: true,
                component: () => import('@/views/dashboard/Pages/BlockEditor.vue'),
                meta: { title: 'Studies Weekly Store - Block Editor'}
            }
        ]
    },
    {
        path: 'allOrders',
        name: 'all-orders',
        component: () => import('@/views/dashboard/Orders/AllOrders.vue'),
        meta: {
            title: "Studies Weekly Store - OrderDetails Admin",
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        },
    },
    {
        path: 'store-admin',
        name: 'store-admin',
        component: () => import('../views/dashboard/StoreAdmin.vue'),
        meta: {
            title: 'Studies Weekly Store - Store Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'tax-admin',
        name: 'tax-admin',
        component: () => import('../views/dashboard/TaxAdmin.vue'),
        meta: {
            title: 'Studies Weekly Store - Tax Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'images',
        name: 'images',
        component: () => import('../views/dashboard/ImageAdmin.vue'),
        meta: {
            title: 'Studies Weekly Store - Image Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'markets',
        name: 'markets',
        component: () => import('../views/dashboard/PriceOverride.vue'),
        meta: {
            title: 'Studies Weekly Store - Market Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'charter-schools',
        name: 'charter-schools',
        component: () => import('@/views/dashboard/CharterSchools.vue'),
        meta: {
            title: 'Studies Weekly Store - Charter Schools Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'affiliate-list',
        name: 'affiliate-list',
        component: () => import('../views/dashboard/AffiliateList.vue'),
        meta: {
            title: 'Studies Weekly Store - Affiliate List',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'ship-rates',
        name: 'ship-rates',
        component: () => import('../views/dashboard/ShippingRates.vue'),
        meta: {
            title: 'Studies Weekly Store - Ship Rates Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'idle-carts',
        name: 'idle-carts',
        component: () => import('../views/dashboard/Orders/IdleCarts.vue'),
        meta: {
            title: 'Studies Weekly Store - Idle Carts',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }

        }
    },
    {
        path: 'costs',
        name: 'costs',
        component: () => import('../views/dashboard/CostsChecker.vue'),
        meta: {
            title: 'Studies Weekly Store - Costs Checker',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'adoptions',
        name: 'adoptions',
        component: () => import('../views/dashboard/Adoptions.vue'),
        meta: {
            title: 'Studies Weekly Store - Adoptions Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'schoolYear',
        name: 'schoolYear',
        component: () => import('../views/dashboard/StateYearMapping.vue'),
        meta: {
            title: 'Studies Weekly Store - School Year Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'user-admin',
        name: 'user-admin',
        component: () => import('../views/dashboard/UserAdmin.vue'),
        meta: {
            title: 'Studies Weekly Store - User Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'pageMapViewer',
        name: 'pageMapViewer',
        component: () => import('../views/dashboard/Products/PageMapping.vue'),
        meta: {
            title: 'Studies Weekly Store - Page Preview',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'customerAdmin/:defaultCustomerId?',
        name: 'customerAdmin',
        props: true,
        component: () => import('../views/dashboard/Customers/CustomerAdmin.vue'),
        meta: {
            title: 'Studies Weekly Store - Customer Admin',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'customerEdit/:customerId?',
        name: 'customerEdit',
        props: true,
        component: () => import('../views/dashboard/Customers/CustomerEdit.vue'),
        meta: {
            title: 'Studies Weekly Store - Customer Page',
        }
    },
    {
        path: 'store-config',
        name: 'store-config',
        component: () => import('../views/dashboard/StoreConfig.vue'),
        meta: {
            title: 'Studies Weekly Store - Store Config',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    {
        path: 'south-dakota',
        name: 'south-dakota',
        component: () => import('../views/dashboard/SDOrders.vue'),
        meta: {
            title: 'Studies Weekly Store - South Dakota',
            auth: {
                roles: ['admin'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: {
                    name: 'error-404'
                },
                notFoundRedirect: {
                    name: 'error-404'
                }
            }
        }
    },
    ]
}];